import React, { useEffect, useRef, useState } from 'react';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { DownloadStoriesPreviewModel } from '@/types/home';
import CustomersTalkUsContent from './CustomersTalkUsContent';

const FAQContent = dynamic(() => import('./FAQContent'), { ssr: true });
const DownloadInstagramContent = dynamic(() => import('./DownloadInstagramContent'), { ssr: true });
const TopSearchContent = dynamic(() => import('./TopSearch'), { ssr: true });
const ChooseContent = dynamic(() => import('./ChooseContent'), { ssr: true });
const GeneralExampDownloadContent = dynamic(() => import('./GeneralExampDownloadContent'), {
  ssr: true,
});
const WhyDownloadStoriesContent = dynamic(() => import('./WhyDownloadStoriesContent'), {
  ssr: true,
});
const InstagramActivityTrackerContent = dynamic(() => import('./InstagramActivityTracker'), {
  ssr: true,
});
const BestTipsContent = dynamic(() => import('./BestTipsContent'), { ssr: true });
const DownloadStoriesBottomContent = dynamic(() => import('./DownloadStoriesBottomContent'), {
  ssr: true,
});
const RecentFollowResultContent = dynamic(() => import('../RecentFollow/RecentFollowResult'), {
  ssr: false,
});

const InstagramTrackerSubContent = ({ data }: { data?: any }) => {
  const [contentData, setContentData] = useState<DownloadStoriesPreviewModel>(data?.contentData);
  const resultRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [searchStr, setSearchStr] = useState('');
  const [inputVisible, setInputVisible] = useState(true);

  useEffect(() => {
    setContentData(data?.contentData);
  }, [data]);

  const onValueChanged = (e?: string) => {
    setSearchStr(e ?? '');
  };

  const onSearchClick = (e?: string) => {
    setTimeout(() => {
      const event = new CustomEvent('recentFollowBottomSearch', {
        detail: e,
      });
      window.dispatchEvent(event);
    }, 900);
  };

  const onScrollToInputSection = (e?: string) => {
    if (resultRef?.current) {
      const targetTop = resultRef.current.offsetTop - 60;

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth',
      });

      if (e) {
        onSearchClick(e);
      }
    }
  };

  return (
    <>
      <CommonBackContent style={{ minHeight: '100vh' }}>
        <TopSearchContent
          hideSearch={true}
          topInfo={contentData?.contentInfo?.hero}
          loading={loading}
          searchVal={searchStr}
          onValueChanged={onValueChanged}
        />

        <div ref={resultRef}>
          <RecentFollowResultContent
            searchVal={searchStr}
            onValueChanged={onValueChanged}
            onInputVisibleChanged={(visible) => setInputVisible(visible)}
            onStartSearchClick={() => {
              setTimeout(() => {
                onScrollToInputSection();
              }, 10);
            }}
            onLoading={(loading) => setLoading(loading)}
          />
        </div>

        <DownloadInstagramContent data={contentData?.contentInfo['section-1']} />
        <ChooseContent data={contentData?.contentInfo['section-2']} />
        <GeneralExampDownloadContent data={contentData?.contentInfo['section-3']} />
        <WhyDownloadStoriesContent data={contentData?.contentInfo['section-4']} />
        <InstagramActivityTrackerContent
          contentData={contentData}
          isTracker={true}
          webBg={'https://res-front.pumpsoul.com/ins-prod/image/activity_tracker_bg_web_0110_1.webp'}
          phoneBg={'https://res-front.pumpsoul.com/ins-prod/image/activity_tracker_bg_phone_0109.webp'}
        />

        <CustomersTalkUsContent contentInfo={contentData?.contentInfo?.['section-user-reviews']} />
        {contentData?.faqList && (
          <FAQContent faqInfo={contentData?.contentInfo?.['section-faq']} faqList={contentData?.faqList} />
        )}

        <BestTipsContent
          title={contentData?.contentInfo?.['section-top-blog']?.title}
          blogList={contentData?.topBlogList}
        />
        <BestTipsContent title={contentData?.contentInfo?.['section-blog']?.title} blogList={contentData?.blogList} />
      </CommonBackContent>

      <DownloadStoriesBottomContent
        bottomInfo={contentData?.contentInfo['section-buttom']}
        placeholder={t('Instagram Username (@name)')}
        buttonTitle={t('Reveal Now')}
        loading={loading}
        searchVal={searchStr}
        inputVisible={inputVisible}
        onValueChanged={onValueChanged}
        onSearchClick={(e) => {
          onScrollToInputSection(e);
        }}
      />
    </>
  );
};

export default InstagramTrackerSubContent;
